import axios from "axios";

// axios.defaults.baseURL = "http://localhost:8000";
axios.defaults.baseURL = "https://countries-api-tan.vercel.app/"

export default axios;
